import { Card, Typography } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

const GeneralSettings: FC = () => {
  const { t } = useTranslation('settings.GeneralSettings');

  return (
    <Card>
      <Title level={4}>{t('title')}</Title>
      <Text>{t('description')}</Text>
    </Card>
  );
};

export default GeneralSettings;
